import React from "react";
import "./CardGrid.scss";
import { checkAccess } from "../utils/apiUtils";
import { useHistory } from "react-router-dom";

function Card(props) {
  const history = useHistory();

  const handleClick = () => {
    if (
      (props.item.isAutomation ||
        props.item.isMisReport ||
        props.item.isLrReport ||
        props.item.isSoAutomation|| props.item.isMergeMis) &&
      props.isLoading
    ) {
      return;
    }

    if (
      (props.item.isAutomation ||
        props.item.isMisReport ||
        props.item.isLrReport ||
        props.item.isSoAutomation ||
        props.item.isMergeMis) &&
      props.onClick
    ) {
      props.onClick();
    } else if (props.item.isReport) {
      window.open(props.item.url, "_blank");
    } else if (props.isBranch && props.item.branchId) {
      history.push({
        pathname: props.item.url,
        state: {
          selectedBranchId: props.item.branchId,
          selectedBranchName: props.item.label,
        },
      });
    } else {
      history.push(props.item.url);
    }
  };

  return (
    <div
      className={`card-${props.index} btnfos-5 ${
        props.isLoading ? "card-loading" : ""
      }`}
      tabIndex="0"
      onKeyPress={(e) => {
        if (e.key === "Enter") handleClick();
      }}
      onClick={handleClick}
    >
      <span className="card-icon">{props.item.icon}</span>
      <div className="card-text">{props.item.label}</div>
    </div>
  );
}

export default Card;
